// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"03e00563","126":"7a6d35c0","255":"ec530777","292":"3a61974a","671":"0dcda3f5","809":"b5c2d267"}[chunkId] + ".chunk.css";
};